<template>
  <div style="padding-top:80px;">
    <!-- hero area -->
    <div class="hero-area hero-bg wave-bg">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2 text-center">
            <div class="hero-text">
              <div class="hero-text-tablecell">
                <p class="subtitle">快速 稳定 高效</p>
                <h1>Blade<span style="color: #FFE018;">X</span>企业级开发平台</h1>
                <p class="introduce">
                  <span>BladeX是一款精心设计的微服务架构，提供 SpringCloud 全套解决方案</span>
                  <br>
                  <span>开源中国首批完美集成 SpringCloud Alibaba 系列组件的微服务架构</span>
                  <br>
                  <span>基于稳定生产的商业项目升级优化而来，更加贴近企业级的需求</span>
                  <br>
                  <span>追求企业开发更加高效，部署更加方便，生产更加稳定</span>
                  <br>
                  <span>荣获开源中国年度最受欢迎开源软件TOP30</span>
                  <br>
                  <span>荣获开源中国年度应用软件类TOP2</span>
                  <br>
                  <span>码云最有价值开源项目&nbsp;<a href="https://gitee.com/smallc/SpringBlade"><img src="https://gitee.com/smallc/SpringBlade/badge/star.svg?theme=gvp" alt="star"></a></span>
                </p>
                <p class="changelog">
                  <span>当前版本 4.5.0.RELEASE</span>
                  <router-link to="/doc/biz-changelog">
                    <span style="color: #FFE018;">更新日志</span>
                  </router-link>
                  <a href="https://sns.bladex.cn/article-15011.html"><span style="color: #FFE018;">安全指南</span></a>
                  <a href="https://gitee.com/smallc/SpringBlade"><span style="color: #FFE018;">码云</span></a>
                  <a href="https://github.com/chillzhuang/SpringBlade"><span style="color: #FFE018;">Github</span></a>
                </p>
                <div class="hero-btns">
                  <a href="/#/doc/introduction" class="boxed-btn">
                    <span>开源版</span>
                  </a>
                  <a href="/#/vip" class="bordered-btn">
                    商业授权
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div><!-- end hero area -->
    <!-- services -->
    <div class="section-padding service-section wow bounceInUp"
         data-wow-duration="1s"
         data-wow-delay="0s">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2 text-center">
            <div class="section-title">
              <h3>功能模块</h3><span><i class="fab fa-canadian-maple-leaf"></i></span>
              <p>针对企业通用业务场景定制，满足大部分核心需求
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="single-service-box">
              <div class="service-text">
                <h3>独特的多租户架构</h3>
                <p>符合中国式需求的多租户架构，支持多租户一数据库、一租户一数据库、多租户多数据库等多种模式灵活组合。</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="single-service-box">
              <div class="service-text">
                <h3>完善的权限管理</h3>
                <p>系统提供菜单按钮权限、数据权限、接口权限三种配置。基于注解+Web的组合配置方式，灵活多变，即时生效。</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
            <div class="single-service-box">
              <div class="service-text">
                <h3>协同办公工作流</h3>
                <p>深度定制了满足SpringCloud分布式场景的Flowable工作流，为复杂流程保驾护航，同时提供SpringBoot集成版本。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="single-service-box">
              <div class="service-text">
                <h3>在线报表设计器</h3>
                <p>基于架构在Spring之上的纯Java的高性能报表引擎，通过迭代单元格可以实现任意复杂的中国式报表。</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="single-service-box">
              <div class="service-text">
                <h3>主流数据库兼容</h3>
                <p>一套代码完全兼容Mysql、Oracle、PostgreSQL、SqlServer、达梦等主流数据库，为各场景提供强力支持。</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
            <div class="single-service-box">
              <div class="service-text">
                <h3>全能代码生成器</h3>
                <p>支持自定义模型、模版 、业务建模，支持多种模板引擎，在线配置。大幅度提升开发效率，不再为重复工作发愁。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 text-center">
            <a href="#" onclick="window.location.href='/#/doc/biz-list'" class="boxed-btn">
              了解更多
            </a>
          </div>
        </div>
      </div>
    </div><!--  end services -->
    <!-- featured section -->
    <div class="featured-section featured-bg">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6">
            <div class="featured-box">
              <div class="featured-text">
                <h3>走在技术前沿</h3>
                <p>采用前沿而又通过生产检验的技术，整体架构完全领先业内常规架构。在享受新技术开发带来便利的同时，又能体验新技术的核心思想与最佳实践。</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="featured-box">
              <div class="featured-text">
                <h3>多平台支持</h3>
                <p>后端提供基于SpringCloud的分布式架构与基于SpringBoot的单体式架构，前端提供基于React与Vue的两套前端架构，为各种类型的项目保驾护航。</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="featured-box">
              <div class="featured-text">
                <h3>完整的生产部署方案</h3>
                <p>支持FatJar、Docker、K8s、阿里云等多种部署方式，提供完整的云端部署方案。引入敏捷开发、持续集成、持续交付等理念，助力企业产品快速迭代。</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="featured-box">
              <div class="featured-text">
                <h3>成熟的社区</h3>
                <p>Blade问答社区完全开放，所有用户均可登录交流。可以将使用框架遇到的问题提出来获取答案，也可以浏览历史提问，获取到众多解决方案，共建完善的生态。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end featured section -->
    <!-- advertisement section -->
<!--    <div class="advertisement-section wow slideInLeft section-padding-top"
         data-wow-duration="1s"
         data-wow-delay="0s">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-12">
            <div class="advertisement-bg">
            </div>
          </div>
          <div class="col-lg-6 col-md-12">
            <div class="featured-text">
              <h2>BladeX微服务架构</h2>
              <p>1.基于SpringBoot3、SpringCloud 2023、Mybatis构建核心架构</p>
              <p>2.采用Oauth2协议进行统一的Token下发与鉴权，保证系统安全性</p>
              <p>3.使用Gateway进行网关的统一转发，网关进行统一鉴权</p>
              <p>4.微服务统一注册至Nacos，Nacos担任注册中心与配置中心的角色</p>
              <p>5.采用Feign进行远程调用，LoadBalancer进行负载</p>
              <p>6.采用Sentinel进行限流和熔断，保障系统整体的性能</p>
              <p>7.集成Seata，为分布式事务保驾护航</p>
              <p>8.具有日志收集与监控服务为一体的能力</p>
              <p>9.支持FatJar、Docker、K8s、阿里云等多种部署方式</p>
            </div>
          </div>
        </div>
      </div>
    </div>-->
    <!-- end advertisement section -->
    <!-- cta area -->
<!--    <div class="cta-area mg-top-150 mg-bottom-150 wow fadeIn"
         data-wow-duration="1s"
         data-wow-delay="0s">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-18">
            <div class="cta-text">
              <h3>为何需要BladeX ?</h3>
              <p>
                1. 经历过较长的线上生产，积累了很多企业痛点的解决方案。
              </p>
              <p>
                2. 兼容MySql、Oracle、PGSQL、SqlServer、达梦、崖山，适应企业各种不同场景的需求。
              </p>
              <p>
                3. 集成了很多企业急切所需的例如多租户、Oauth2授权认证、工作流、分布式事务等等功能。
              </p>
              <p>
                4. 集成最新版本ELK，界面美观，功能强大。同时深度定制了日志模块，支持分布式日志追踪功能。
              </p>
              <p>
                5. 深度定制了Flowable工作流，完美支持SpringCloud分布式服务的场景，以远程调用的方式进行操作。
              </p>
              <p>
                6. 升级了核心驱动，新功能完全可以开箱即用，而开源版需要自己再花时间进行集成，需要花掉更多的时间成本。
              </p>
              <p>
                7. 拥抱微服务时代，很多企业由于项目转型或升级，传统的技术已然不能满足，反而会花更多成本，而BladeX就是为此而生。
              </p>
              <p>
                8. 同时提供SpringCloud版本和SpringBoot版本，两个版本的api可以与Sword和Saber无缝对接，为小型项目至大型项目保驾护航。
              </p>
              <p>
                9. 授权购买即永久，源码没有混淆，完全开放，后续升级完全免费。企业只需花很少的钱即可获得一整套成熟的解决方案，你还在等什么？
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>-->
    <!-- end cta area -->
    <!-- latest news -->
    <div class="latest-news wow slideInLeft mg-top-150 "
         data-wow-duration="1s"
         data-wow-delay="0s">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2 text-center">
            <div class="section-title">
              <h3>系统界面</h3><span><i class="fab fa-canadian-maple-leaf"></i></span>
              <p>基于Vue2、Vue3构建两套独立的前端系统，风格优点各有所长
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="single-latest-news">
              <a href="https://saber.bladex.cn">
                <div class="latest-news-bg news-bg-1"></div>
              </a>
              <div class="news-text-box">
                <h3><a href="https://saber.bladex.cn">协同办公</a></h3>
                <p class="excerpt">深度定制了最新版Flowable工作流</p>
                <p class="excerpt">提供汉化的独立流程设计器</p>
                <a href="https://saber.bladex.cn" class="service-btn">
                  查看演示
                  <i class="fas fa-angle-right"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="single-latest-news">
              <a href="https://saber.bladex.cn">
                <div class="latest-news-bg news-bg-2"></div>
              </a>
              <div class="news-text-box">
                <h3><a href="https://saber.bladex.cn">流程信息</a></h3>
                <p class="excerpt">完美支持分布式场景的流程调用</p>
                <p class="excerpt">可以清晰看到流程每个节点的详细信息</p>
                <a href="https://saber.bladex.cn" class="service-btn">
                  查看演示
                  <i class="fas fa-angle-right"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
            <div class="single-latest-news">
              <a href="https://saber.bladex.cn">
                <div class="latest-news-bg news-bg-3"></div>
              </a>
              <div class="news-text-box">
                <h3><a href="https://saber.bladex.cn">流程跟踪</a></h3>
                <p class="excerpt">提供丰富的流程API，开箱即用</p>
                <p class="excerpt">可以看到当前流程具体的节点状态</p>
                <a href="https://saber.bladex.cn" class="service-btn">
                  查看演示
                  <i class="fas fa-angle-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="single-latest-news">
              <a href="https://saber.bladex.cn">
                <div class="latest-news-bg news-bg-4"></div>
              </a>
              <div class="news-text-box">
                <h3><a href="https://saber.bladex.cn">功能权限</a></h3>
                <p class="excerpt">在线配置菜单功能权限</p>
                <p class="excerpt">权限精确至按钮</p>
                <a href="https://saber.bladex.cn" class="service-btn">
                  查看演示
                  <i class="fas fa-angle-right"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="single-latest-news">
              <a href="https://saber.bladex.cn">
                <div class="latest-news-bg news-bg-5"></div>
              </a>
              <div class="news-text-box">
                <h3><a href="https://saber.bladex.cn">数据权限</a></h3>
                <p class="excerpt">提供注解+Web两种组合配置方式</p>
                <p class="excerpt">支持按人、机构、自定义配置数据权限</p>
                <a href="https://saber.bladex.cn" class="service-btn">
                  查看演示
                  <i class="fas fa-angle-right"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
            <div class="single-latest-news">
              <a href="https://saber.bladex.cn">
                <div class="latest-news-bg news-bg-6"></div>
              </a>
              <div class="news-text-box">
                <h3><a href="https://saber.bladex.cn">接口权限</a></h3>
                <p class="excerpt">提供注解+Web两种组合配置方式</p>
                <p class="excerpt">在线配置，即时生效</p>
                <a href="https://saber.bladex.cn" class="service-btn">
                  查看演示
                  <i class="fas fa-angle-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="single-latest-news">
              <a href="https://saber.bladex.cn">
                <div class="latest-news-bg news-bg-7"></div>
              </a>
              <div class="news-text-box">
                <h3><a href="https://saber.bladex.cn">多租户对象存储</a></h3>
                <p class="excerpt">支持各租户自定义私有OSS的配置</p>
                <p class="excerpt">可将附件直接上传至私有OSS，提高安全性</p>
                <a href="https://saber.bladex.cn" class="service-btn">
                  查看演示
                  <i class="fas fa-angle-right"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="single-latest-news">
              <a href="https://saber.bladex.cn">
                <div class="latest-news-bg news-bg-8"></div>
              </a>
              <div class="news-text-box">
                <h3><a href="https://saber.bladex.cn">在线报表</a></h3>
                <p class="excerpt">支持在线配置的高性能报表引擎</p>
                <p class="excerpt">通过迭代单元格可以实现任意复杂的中国式报表</p>
                <a href="https://saber.bladex.cn" class="service-btn">
                  查看演示
                  <i class="fas fa-angle-right"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
            <div class="single-latest-news">
              <a href="https://saber.bladex.cn">
                <div class="latest-news-bg news-bg-9"></div>
              </a>
              <div class="news-text-box">
                <h3><a href="https://saber.bladex.cn">全能代码生成器</a></h3>
                <p class="excerpt">支持自定义业务建模</p>
                <p class="excerpt">在线配置模型、模版，灵活生成</p>
                <a href="https://archer.bladex.cn" class="service-btn">
                  查看演示
                  <i class="fas fa-angle-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div><!-- end latest news -->
    <!-- cta area -->
<!--    <div class="cta-area mg-top-150 mg-bottom-150 wow fadeIn"
         data-wow-duration="1s"
         data-wow-delay="0s">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-18">
            <div class="cta-text">
              <h3>BladeX有哪些产品 ?</h3>
              <p>
                1. BladeX ：         基于SpringCloud的分布式框架
              </p>
              <p>
                2. BladeX-Boot ：    基于SpringBoot的单体式框架
              </p>
              <p>
                3. BladeX-Biz ：     适用于多团队开发的分布式业务框架
              </p>
              <p>
                4. BladeX-Tool ：    BladeX系列核心封装架构
              </p>
              <p>
                5. Saber ：          基于Avue、Vue、ElementUI的前端框架
              </p>
              <p>
                6. Sword ：          基于React、AntDesign的前端框架
              </p>
              <p>
                7. Rider ：          基于UniApp的移动端跨平台框架
              </p>
              <p>
                8. Archer ：         独立的全能代码生成系统
              </p>
              <p>
                9. Caster ：         数据大屏展示系统
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>-->
    <!-- end cta area -->
    <!-- latest news -->
    <div class="latest-news wow slideInLeft mg-top-150 "
         data-wow-duration="1s"
         data-wow-delay="0s">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2 text-center">
            <div class="section-title">
              <h3>监控界面</h3><span><i class="fab fa-canadian-maple-leaf"></i></span>
              <p>基于Prometheus搭建的全方位监控体系
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="single-latest-news">
              <div class="news-text-box">
                <h3><a href="#">Linux服务器监控</a></h3>
                <p class="excerpt">详细监控服务器资源、CPU、磁盘、内存等指标</p>
                <p class="excerpt">若服务器异常则可通过Alertmanager告警通知</p>
              </div>
              <a href="#">
                <div class="latest-news-bg-high news-bg-10"></div>
              </a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="single-latest-news">
              <div class="news-text-box">
                <h3><a href="#">Mysql服务监控</a></h3>
                <p class="excerpt">详细监控Mysql链接数、QPS、内存等指标</p>
                <p class="excerpt">若Mysql异常则可通过Alertmanager告警通知</p>
              </div>
              <a href="#">
                <div class="latest-news-bg-high news-bg-11"></div>
              </a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="single-latest-news">
              <div class="news-text-box">
                <h3><a href="#">Docker服务监控</a></h3>
                <p class="excerpt">详细监控Docker运行数量、CPU、内存等指标</p>
                <p class="excerpt">若Docker异常则可通过Alertmanager告警通知</p>
              </div>
              <a href="#">
                <div class="latest-news-bg-high news-bg-12"></div>
              </a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="single-latest-news">
              <div class="news-text-box">
                <h3><a href="#">Jvm服务监控</a></h3>
                <p class="excerpt">详细监控每个微服务的并发、QPS、CPU、内存等指标</p>
                <p class="excerpt">若Jvm异常则可通过Alertmanager告警通知</p>
              </div>
              <a href="#">
                <div class="latest-news-bg-high news-bg-13"></div>
              </a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="single-latest-news">
              <div class="news-text-box">
                <h3><a href="#">Nacos服务监控</a></h3>
                <p class="excerpt">详细监控Nacos进程数、QPS、CPU等指标</p>
                <p class="excerpt">若Nacos异常则可通过Alertmanager告警通知</p>
              </div>
              <a href="#">
                <div class="latest-news-bg-high news-bg-14"></div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div><!-- end latest news -->
    <!-- cta area -->
    <div class="cta-area mg-top-150 wow fadeIn"
         data-wow-duration="1s"
         data-wow-delay="0s">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 col-md-12">
            <div class="cta-text">
              <h3>成熟的技术社区，等待您的到来</h3>
              <p>- BladeX问答社区，程序员的技术进阶之路，您的指路明灯</p>
              <p>- 掌握提问的艺术，遇到难题能令您事半功倍</p>
              <p>- 欢迎大家前往社区交流提问</p>
            </div>
          </div>
          <div class="col-lg-4 col-md-12 text-right">
            <div class="cta-btn">
              <a href="https://sns.bladex.cn/" class="boxed-btn">
                前往社区
              </a>
            </div>
          </div>
        </div>
      </div>
    </div><!-- end cta area -->
  </div>
</template>

<script>
export default {
  name: "home",
  data () {
    return {

    };
  },
  created() {
    setTimeout(() => {
      this.notice = this.$notify.success({
        title: "BladeX 新产品通知",
        dangerouslyUseHTMLString: true,
        message: `
        <p>----------------------------</p>
        <p>《BladeXAI大模型平台》正式发售通知</p>
        <p>----------------------------</p>
        <p>1.「三位一体」智能架构提供灵活的 Chat、Agent、RAG 模式，满足不同业务需求，让智能化升级触手可及。</p>
        <p>2. 老用户购买额外优惠：￥2,000元。</p>
        <p>3. 系统演示：<a target="_blank" href="https://aigc.bladex.cn/">查看演示</a></p>
        <p>4. 官网地址：很快到来，敬请期待。</p>
        <p>5. 商务联系：<a target="_blank" href="https://bladex.cn/#/contract">点击查看</a></p>
        <p>----------------------------</p>
        <p>《BladeX物联网平台》正式发售通知</p>
        <p>----------------------------</p>
        <p>1.「纯自研MQTT」「EMQX+Kafka」双架构，支持单机与集群双模式切换，满足不同业务场景，助力万物互联。</p>
        <p>2. 老用户购买额外优惠：￥2,000元。</p>
        <p>3. 系统演示：<a target="_blank" href="https://iot.javablade.com/">查看演示</a></p>
        <p>4. 官网地址：<a target="_blank" href="https://iot.bladex.cn/">查看官网</a></p>
        <p>5. 商务联系：<a target="_blank" href="https://bladex.cn/#/contract">点击查看</a></p>
        <p>----------------------------</p>`,
        duration: 0,
        offset: 50,
        position: 'bottom-right',
        type: "success"
      });
    }, 500);
  },
  destroyed() {
    this.notice.close();
  },
  mounted () {
    new window.WOW().init();
  }
};
</script>

<style lang="scss">
.hero-area {
  height: 750px;
}
.introduce {
  font-size: 16px;
  line-height: 32px;
  font-weight: 400;
  max-width: 557px;
  margin: 40px auto 25px;
}
.changelog {
  margin-bottom: 30px;
  color: #fff;
  font-size: 13px;
  span {
    margin-right: 10px;
  }
  a {
    color: #fff;
    font-size: 13px;
    text-decoration: underline;
  }
}
</style>
